import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Bannerfrom from "../components/bannerfrom";
import {Link} from 'gatsby';

function Banner(props) {
    return (
        <div className="services_location_banner">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={6} xl={7} xxl={7} className="my-auto">
                        <div className="banenr_content">
                            <div className="example" data-text="Washington">
                                <h1>Custom Software Development In <span>Washington</span></h1>
                            </div>
                            <p className="main_para">Build scalable and distinct solutions for your business growth through a performance-oriented software development company in Washington DC, using the right tools, technologies, and a winning culture.</p>
                            <Link to="/contact"
                            className="border_btn" aria-label="TekRevol Contact"> Let’s Get Started</Link>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
                        <Bannerfrom/>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Banner;